import React, { useState } from 'react';

const AccountantDrawLotteryList = () => {
  const [selectedDate, setSelectedDate] = useState('2026-02-17');

  const lotteryData = [
    {
      id: 1,
      applicantName: 'रमेश भाऊसाहेब पाटील',
      phoneNumber: '9876543210',
      taluka: 'मुरबाड',
      workName: 'शेतीची आधुनिकीकरण योजना',
      amount: '50,000'
    },
    {
      id: 2,
      applicantName: 'सुनीता राजेंद्र जाधव',
      phoneNumber: '9876543211',
      taluka: 'कल्याण',
      workName: 'पाणीपुरवठा योजना',
      amount: '75,000'
    },
    {
      id: 3,
      applicantName: 'दिपक तुकाराम गायकवाड',
      phoneNumber: '9876543212',
      taluka: 'भिवंडी',
      workName: 'रस्ते विकास काम',
      amount: '1,00,000'
    },
    {
      id: 4,
      applicantName: 'अंजली सुरेश शिंदे',
      phoneNumber: '9876543213',
      taluka: 'ठाणे',
      workName: 'शैक्षणिक सुविधा विकास',
      amount: '60,000'
    },
    {
      id: 5,
      applicantName: 'विकास रमेश ठाकूर',
      phoneNumber: '9876543214',
      taluka: 'पालघर',
      workName: 'आरोग्य सुविधा विकास',
      amount: '80,000'
    }
  ];

  const handleSearch = () => {
    console.log('Searching for date:', selectedDate);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-slate-800 text-white shadow-md">
        <div className="container mx-auto px-6 py-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-2">सु.बे. लॉटरी यादी</h1>
            <div className="w-24 h-0.5 bg-blue-400 mx-auto mb-3"></div>
            <h2 className="text-lg font-normal">ठाणे जिल्हा परिषद / सु.बे. लॉटरी यादी</h2>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="container mx-auto px-6 py-6">
        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <div className="flex flex-col">
              <label htmlFor="lottery-date" className="text-gray-700 font-medium mb-1">
                लॉटरीची तारीख निवडा
              </label>
              <input
                type="date"
                id="lottery-date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none"
              />
            </div>
            <button 
              onClick={handleSearch}
              className="bg-blue-600 text-white px-6 py-2 rounded font-medium hover:bg-blue-700 transition-colors"
            >
              Search
            </button>
          </div>
        </div>

        {/* Table Section */}
        <div className="mt-6 bg-white rounded-lg shadow border border-gray-200">
          <div className="bg-gray-100 px-4 py-3 border-b border-gray-300">
            <h3 className="text-base font-semibold text-gray-800">लॉटरी यादीची माहिती</h3>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-700 text-white">
                <tr>
                  <th className="px-4 py-3 text-left font-medium text-sm">क्रमांक</th>
                  <th className="px-4 py-3 text-left font-medium text-sm">अर्जदाराचे नाव</th>
                  <th className="px-4 py-3 text-left font-medium text-sm">फोन नंबर</th>
                  <th className="px-4 py-3 text-left font-medium text-sm">तालुका</th>
                  <th className="px-4 py-3 text-left font-medium text-sm">कामाचे नाव</th>
                  <th className="px-4 py-3 text-left font-medium text-sm">रक्कम</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {lotteryData.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{item.id}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{item.applicantName}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{item.phoneNumber}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{item.taluka}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{item.workName}</td>
                    <td className="px-4 py-3 text-sm font-semibold text-green-700">₹{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantDrawLotteryList;
